import { AbstractControl, AsyncValidatorFn, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import {
  PaymentFormField,
  PaymentFormFieldConfig,
  PaymentFormFieldHooks,
} from '@backbase/initiate-payment-journey-ang';

/**
 * Registers a FormControl in the provided FormGroup
 *
 * @param group
 * @param formControlName
 * @param [validators]
 * @param [asyncValidators]
 * @param [initialValue='']
 * @returns
 */
export function registerFormControl(
  group: FormGroup,
  formControlName: string,
  validators?: Array<ValidatorFn>,
  asyncValidators?: Array<AsyncValidatorFn>,
  initialValue: unknown = '',
  config?: PaymentFormFieldConfig,
): AbstractControl {
  let formControl: AbstractControl;
  formControl = group.controls[formControlName];
  group.addControl(formControlName, new FormControl(initialValue, validators || [], asyncValidators || []));

  if (formControl) {
    resetValidators(formControl, validators, asyncValidators, config);
  } else {
    group.addControl(formControlName, new FormControl(initialValue, validators || [], asyncValidators || []));
    formControl = group.controls[formControlName];
  }

  return formControl;
}

export function resetValidators(
  formControl: AbstractControl,
  validators?: Array<ValidatorFn>,
  asyncValidators?: Array<AsyncValidatorFn>,
  config?: PaymentFormFieldConfig,
) {
  const computedValidators = validators ? [...validators] : [];

  if (!config?.hidden && config?.options?.isConditionalMandatory) {
    computedValidators.push(Validators.required);
  }

  formControl.markAsUntouched();
  formControl.clearValidators();
  formControl.clearAsyncValidators();
  formControl.setAsyncValidators(asyncValidators || []);
  formControl.setValidators(computedValidators);
}

export function triggerHook(name: PaymentFormFieldHooks, component: PaymentFormField) {
  let control: FormControl = new FormControl();

  if (component.group) {
    control = component.group.get(component.config.name) as FormControl ?? control;
  }
  const hook = component.config?.hooks && component.config?.hooks[name];
  if (typeof hook === 'function') {
    // Triggering the hook with component specific parameters
    hook({
      component, // The component instance
      control, // The component form field
      group: component.group, // The parent form group
    });
  }
}
